import { t } from 'i18next'

const notNullOrUndefined = (value) => value !== null && value !== undefined

const encodeInBase64Url = (values) => {
  if (!values) {
    return ''
  }
  const jsonString = JSON.stringify(values)
  const encoded = encodeURIComponent(jsonString)

  return btoa(encoded)
}

const putIntoUrl = (params) => {
  const queryString = new URLSearchParams(params).toString()
  const newUrl = `${window.location.pathname}?${queryString}`
  window.history.pushState({}, '', newUrl)
}

const readFromUrl = (paramName) => {
  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.get(paramName)
}

const decodeFromBase64Url = (value) => {
  if (!value) {
    return null
  }

  const decoded = decodeURIComponent(atob(value))
  const parsed = JSON.parse(decoded)
  return parsed
}

const translateErrors = ({ module = 'common', status, keys = [], ...interpolationData }) => {
  const statusToErorr = {
    409: 'errors.conflict'
  }

  const statusError = statusToErorr[status] ? statusToErorr[status] : 'error'
  return t(`${module}.${statusError}${keys.length ? `.${keys.join('.')}` : ''}`, interpolationData)
}

export { decodeFromBase64Url, encodeInBase64Url, notNullOrUndefined, putIntoUrl, readFromUrl, translateErrors }
